<template>
  <div class="pc-region-detail">
    <!-- region head -->
    <div class="pc-region-detail-head">
      <div class="pc-region-detail-head-bread">
        <h2>城市管理</h2>
        <BreadCrumb :data="breadcrumb" class="pc-region-detail-breadcrumb" />
      </div>
      <h4 v-show="editRegion == false" @click="edit">管理</h4>
      <h4
        v-show="editRegion == true && oprateType == 'update'"
        @click="
          edit();
          saveArea();
        "
      >
        完成
      </h4>
      <h4
        v-show="editRegion == true && oprateType == 'add'"
        @click="
          edit();
          addRegion();
        "
      >
        新增
      </h4>
    </div>
    <div class="pc-region-base-info">
      <div class="pc-region-detail-information">
        <h2 v-if="editRegion">修改信息</h2>
        <h2 v-else>基本信息</h2>
        <div class="content">
          <div class="cover-img-info">
            <div class="content-cover-img">
              <el-upload
                v-if="editRegion"
                class="logoImg"
                action="#"
                list-type="picture-card"
                accept=".png,.PNG,.jpg,.JPG,.jpeg"
                :http-request="uploadBgImage"
                :show-file-list="false"
                :auto-upload="true"
              >
                <img
                  v-if="regionDetail.bgImage"
                  :src="regionDetail.bgImage"
                  class="upload-image"
                />
                <p v-else class="img-hint">添加城市群封面图</p>
              </el-upload>
              <div class="process" v-if="bgImagePercentage != 0">
                <el-progress
                  type="circle"
                  :width="100"
                  :percentage="bgImagePercentage"
                ></el-progress>
              </div>
              <img
                v-if="!editRegion && regionDetail.bgImage"
                :src="regionDetail.bgImage"
                alt=""
              />
              <div class="img-alt" v-if="!editRegion && !regionDetail.bgImage">
                <p class="iconfont icon-tupian"></p>
                <p>暂无城市群封面图</p>
              </div>
              <p class="img-description">封面图尺寸：1：1</p>
              <!-- <el-input v-model="regionDetail.coverImage"></el-input> -->
            </div>
            <div class="base-info">
              <div class="long-term">
                <p class="title required">中文名称:</p>
                <el-input
                  v-if="editRegion"
                  v-model="regionDetail.name"
                  placeholder="请输入中文名称"
                ></el-input>
                <p class="term-content" v-else>{{ regionDetail.name }}</p>
              </div>
              <div class="long-term">
                <p class="title">英文名称:</p>
                <el-input
                  v-if="editRegion"
                  v-model="regionDetail.englishName"
                  placeholder="请输入英文名称"
                ></el-input>
                <p class="term-content" v-else>
                  {{ regionDetail.englishName }}
                </p>
              </div>
              <div class="region-adcode-region">
                <div class="short-term">
                  <p class="title">城市编号:</p>
                  <el-input
                    v-if="editRegion"
                    v-model="regionDetail.orderNum"
                    placeholder="请输入城市编号"
                  ></el-input>
                  <p class="term-content" v-else>{{ regionDetail.orderNum }}</p>
                </div>
                <div class="short-term lat-lng">
                  <p class="title">地域:</p>

                  <el-select
                    v-if="editRegion"
                    v-model="regionDetail.continent"
                    clearable
                    placeholder="选择大洲"
                    @change="getCountryDicList()"
                  >
                    <el-option
                      v-for="(item, index) in continentList"
                      :key="index"
                      :value="item.name ? item.name : item.englishName"
                      :label="item.name ? item.name : item.englishName"
                      :disabled="item.disabled"
                    >
                    </el-option>
                  </el-select>

                  <el-select
                    v-if="editRegion"
                    v-model="regionDetail.country"
                    clearable
                    placeholder="选择国家"
                    :disabled="regionDetail.continent == null"
                  >
                    <el-option
                      v-for="(item, index) in countryList"
                      :key="index"
                      :value="item.name ? item.name : item.englishName"
                      :label="item.name ? item.name : item.englishName"
                      :disabled="item.disabled"
                    >
                    </el-option>
                  </el-select>

                  <p class="term-content" v-else>
                    {{ regionDetail.continent }} , {{ regionDetail.country }}
                  </p>
                </div>
                <div class="short-term lat-lng">
                  <p class="title">坐标:</p>
                  <el-input
                    v-if="editRegion"
                    v-model="regionDetail.lat"
                    placeholder="横坐标"
                  ></el-input>
                  <el-input
                    v-if="editRegion"
                    v-model="regionDetail.lng"
                    placeholder="纵坐标"
                  ></el-input>
                  <p class="term-content" v-else>
                    {{ regionDetail.lat }},{{ regionDetail.lng }}
                  </p>
                </div>
              </div>
              <div class="">
                <div>
                  <AddCity
                    :managerState="editRegion"
                    :oprateType="oprateType"
                    :name="regionDetail.name"
                    ref="addCity"
                  />
                </div>
              </div>
              <div class="short-term">
                <p class="title">状态:</p>
                <el-switch
                  v-if="editRegion"
                  v-model="regionDetail.status"
                  active-color="#91CC75"
                  inactive-color="#C7C7C7 "
                  :active-value="1"
                  :inactive-value="0"
                  style="align-self: center"
                >
                </el-switch>
                <p v-else class="term-content">
                  {{ regionDetail.status ? "有效" : "失效" }}
                </p>
              </div>
            </div>
          </div>
          <div class="intro">
            <div class="chinese-intro">
              <p class="title">中文简介:</p>
              <el-input
                v-if="editRegion"
                type="textarea"
                v-model="regionDetail.intro"
                placeholder="请输入中文简介"
              ></el-input>
              <p class="term-content" v-else>{{ regionDetail.intro }}</p>
            </div>
                <!-- <TranslateText
      v-show="editUniversty == true"
      :translateWord="translateContent.intro"
       :translateEnglishWord="translateContent.englishIntro"
      @returnTranslate="returnTranslate"
    /> -->
            <Translate v-if="editRegion" @translateContent="translateContent" />
            <div class="english-intro">
              <p class="title">英文简介:</p>
              <el-input
                v-if="editRegion"
                type="textarea"
                v-model="regionDetail.englishIntro"
                placeholder="请输入英文简介"
              ></el-input>
              <p class="term-content" v-else>{{ regionDetail.englishIntro }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TagDetail
      :dataDetail="regionDetail"
      :managerState="editRegion"
      @updateTag="updateTag"
      :filterArr="filterArr"
    />
    <RegionDetailData
      ref="basicData"
      :dataDetail="regionDetail.basicData"
      :editRegion="editRegion"
      :regionName="regionDetail.name"
    />
     <div class="pc-region-button" v-show="editRegion == true">
      <h4
        @click="edit(); getRegion()"
        v-show="oprateType == 'update'"
      >
        恢复
      </h4>
      <h4 @click="edit();
          saveArea()">保存</h4>
    </div>

       <div class="allTemplate" v-show="findTemplate">
      <!-- 中间提示框 -->
      <div class="allTemplate-prompt">
        <span>{{ msgTitle }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Translate from "../../template/Translate.vue";
import TranslateText from "../../template/TranslateText.vue"
import BreadCrumb from "../../template/BreadCrumb";
import AddCity from "./regionDetail/addCity.vue";
import TagDetail from "../../template/TagDetail";
import RegionDetailData from "./regionDetail/regionDetailData.vue";
import {
  getCityGroup,
  updateCityGroup,
  getCities,
  addCityGroup,
  translate,
  getDictionaries,
} from "./regionDetail/regionDetail.gql";
export default {
  data() {
    return {
     // 翻译弹框
      findTemplate:false,
      // 翻译中的提示问题
      msgTitle:'正在翻译中，请不要点击其他地方',
      filterArr:[],
      bgImagePercentage: 0,
      countryList: [],
      continentList: [],
      includeCities: [],
      regionId: "",
      editRegion: false,
      oprateType: "",
      regionDetail: {
        tags: [],
        type: "REGION",
      },
      breadName: "",
    };
  },
  components: {
    AddCity,
    Translate,
    BreadCrumb,
    TagDetail,
    RegionDetailData,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "地图管理", link: "" },
        { name: "城市群管理", link: "/admin/regionList" },
        {
          name: this.breadName ? this.breadName : "添加城市",
          link: "",
        },
      ];
    },
  },
  async created() {
    if (this.$route.query.id == null) {
      this.oprateType = "add";
      this.edit();
    } else {
      this.regionId = this.$route.query.id;
      this.oprateType = "update";
      this.getRegion();
      //  this.getCities()
    }
    this.getContinentDicList("map_position");
  },
  methods: {
    getContinentDicList(type) {
      this.$global
        .GraphqlQuery(this, getDictionaries, { type: type })
        .then((res) => {
          this.continentList = res.data;
        });
    },
    getCountryDicList() {
      console.dir();
      this.$global
        .GraphqlQuery(this, getDictionaries, {
          type: ("map_position_" + this.regionDetail.continent)
            .replace(" ", "_")
            .toLowerCase(),
        })
        .then((res) => {
          this.countryList = res.data;
        });
    },
    translateContent(arg) {
      this.findTemplate=true
      this.msgTitle = "正在翻译中，请不要点击其他地方";
      let content = "";
      let flag = ''
      if (arg == "cTe") {
        content = this.regionDetail.intro;
        flag = '1'
      } else {
        content = this.regionDetail.englishIntro;
        flag = '2'
      }
      this.$global
        .GraphqlMutation(this, translate, {
          data: content,
          flag:flag
        })
        .then((res) => {
          this.findTemplate=false
          if (arg == "cTe") {
            this.$set(this.regionDetail, "englishIntro", res.data);
          } else {
            this.$set(this.regionDetail, "intro", res.data);
          }
        }).catch(err => {
          this.msgTitle = "出现异常了";
          setTimeout(() => {
            this.findTemplate = false;
          }, 2000);
        });
    },
    updateTag(tags) {
      this.regionDetail.tags = tags;
    },
    edit() {
      this.editRegion = (this.editRegion == false) == true ? true : false;
    },
    async uploadBgImage(params) {
      // this.$global.uploadImage(this, params).then((res) => {
      //   this.$set(this.regionDetail, "bgImage", res.split("?")[0]);
      // });
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          this.bgImagePercentage = parseInt(process);
        },
      };
      this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.bgImagePercentage = 0;
        this.$set(this.regionDetail, "bgImage", res.url.split("?")[0]);
      });
    },
    getRegion() {
      this.$global
        .GraphqlQuery(this, getCityGroup, {
          // Parameters
          id: this.regionId,
        })
        .then((res) => {    
          this.regionDetail = res.data[0];
          this.regionDetail.msgTitle = "城市群";
          this.filterArr = []
          this.filterArr.push(this.regionDetail.continent)
          this.filterArr.push(this.regionDetail.country)
          this.breadName = this.regionDetail.name;
          this.getCities(this.regionDetail.name);
          if (this.regionDetail.continent) {
            this.getCountryDicList();
          }
        });
    },
    getCities(args) {
      this.$global
        .GraphqlQuery(this, getCities, {
          // Parameters
          keywords: args,
        })
        .then((res) => {
          console.log(res.data);
        });
    },
    setData() {
      let {
        status,
        englishName,
        name,
        orderNum,
        continent,
        country,
        lng,
        lat,
        bgImage,
        intro,
        englishIntro,
        tags,
        basicData,
      } = this.regionDetail;

      let addedCity = this.$refs.addCity.getAddedCities();
      let cityAdd = [];
      let addedItem = {};

      addedCity.forEach((item) => {
        addedItem.cityId = item.id;
        addedItem.isImportant = item.isImportant;
        cityAdd.push(addedItem);
      });
      let basic = this.$refs.basicData.getBasicData();
      basicData = [];
      basicData.push(basic.area);
      basicData.push(basic.population);
      basicData.push(basic.gdp);

      // if(this.oprateType=='add'){
      const subEntity = {
        cityAdd,
        status,
        englishName,
        name,
        orderNum,
        continent,
        country,
        lng,
        lat,
        bgImage,
        intro,
        englishIntro,
        tags,
        basicData,
      };
      return subEntity;
    },
    saveArea() {
      let subEntity = this.setData();
      this.$global
        .GraphqlMutation(this, updateCityGroup, {
          // Parameters
          id: this.regionDetail.id,
          data: this.$global.checkNull(subEntity),
        })
        .then((res) => {
          this.loading = false;
          this.$global.success(this, "操作成功");
          this.getRegion();
        });
    },
    addRegion() {
      const subEntity = this.setData();
      this.$global
        .GraphqlMutation(this, addCityGroup, {
          data: this.$global.checkNull(subEntity),
        })
        .then((res) => {
          this.oprateType = "update";
          this.$global.success(this, "操作成功");
          this.regionId = res.data[0].id;
          this.$router.push({
            path: "/admin/regionDetail",
            query: { id: res.data[0].id },
            name: "regionDetail",
            params: res.data[0],
          });
          this.getRegion();
        });
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-region-detail {
  .pc-region-button {
    display: flex;
    justify-content: center;
    align-items: center;
    h4 {
      // margin-top: -10px;
      align-self: center;
      font-size: 16px;
      background: $pageViewSmall;
      padding: 10px 29px 14px;
      font-weight: 400;
      color: $base-color;
      font-family: $english;
      border-radius: 4px;
      cursor: pointer;
      margin-left: 20px;
      margin-top: 40px;
    }
    h4:first-of-type {
      background: rgba(84, 112, 198, 0.14);
      color: $pageViewSmall;
      margin-right: 30px;
    }
    // h4:last-of-type{

    // }
  }
  .pc-region-detail-head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $border-color;
    margin-top: 30px;
    padding-bottom: 15px;
    .pc-region-detail-head-bread {
      display: flex;
      h2 {
        align-self: flex-end;
        font-size: 18px;
        margin-right: 40px;
      }
      .pc-breadcrumb {
        margin-top: 26px;
      }
    }
    h4 {
      align-self: flex-end;
      font-size: 16px;
      background: $pageViewSmall;
      padding: 10px 29px 14px;
      font-weight: 400;
      color: $base-color;
      font-family: $english;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .pc-region-base-info {
    box-shadow: $boxshadow;
    padding: 35px 30px 0px;
    margin-top: 40px;
    .pc-region-detail-information {
      > h2 {
        border-bottom: 1px solid $border-color;
        font-size: 20px;
        padding-bottom: 15px;
        color: $mainTitle;
      }
      .content {
        padding: 31px 50px 60px 0px;
        .cover-img-info {
          display: flex;
          // width:90%;
          box-sizing: border-box;
          /deep/ .el-upload--picture-card {
            height: 279px;
            width: 409px;
          }
          .content-cover-img {
            margin-right: 30px;
            position: relative;
            .process {
              position: absolute;
              top: 0px;
              width: 409px;
              height: 279px;
              text-align: center;
              border-radius: 6px;
              border: 1px dashed $timeBtn;
              padding-top: 100px;
              // background: #fbfdff;
              /deep/ .el-progress__text{
                color:$base-color;
              }
            }
            .img-hint {
              font-size: 14px;
              line-height: 279px;
              color: #5470c6;
            }
            .img-description {
              font-size: 12px;
              color: $thirdTitle;
              margin-top: 10px;
            }
            img {
              border-radius: 6px;
              height: 277px;
              width: 407px;
            }
            .img-alt {
              height: 279px;
              width: 409px;
              background: $imgAlt;
              border-radius: 6px;
              padding-top: 100px;
              p {
                margin-bottom: 5px;
                color: $secondTitle;
                text-align: center;
              }
              .iconfont {
                font-size: 32px;
              }
            }
          }
          .base-info {
            width: 100%;
            .required::before{
              content: "*";
              color:red;
            }
            .region-adcode-region,
            .region-continent-country {
              width: 100%;
              display: flex;
            }
            .long-term {
              /deep/ .el-input {
                width: 60%;
              }
            }
            .short-term {
              /deep/ .el-input {
                width: 140px;
              }
            }
            .long-term,
            .short-term {
              display: flex;
              /deep/ .el-input {
                margin-bottom: 20px;
              }
              .title {
                flex-shrink: 0;
                margin-right: 20px;
                width: 80px;
                text-align: right;
                line-height: 40px;
                font-size: 16px;
              }
              .term-content {
                font-weight: bold;
                line-height: 40px;
              }
            }
            .lat-lng {
              .title {
                width: 50px;
              }
              /deep/ .el-input {
                width: 30%;
                margin-right: 10px;
              }
              /deep/ .el-select {
                margin-right: 10px;
                .el-input {
                  width: 100%;
                  margin-right: 10px;
                }
              }
            }
          }
        }
        .intro {
          .title {
            width: 120px;
            flex-shrink: 0;
          }
          .chinese-intro,
          .english-intro {
            margin-bottom: 20px;
            display: flex;
            .term-content {
              font-weight: bold;
            }
          }
          .chinese-intro {
            .title {
              margin-top: 20px;
            }
            .term-content {
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
}
.allTemplate {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    .allTemplate-prompt {
      display: flex;
      justify-content: center;
      align-self: center;
      cursor: pointer;
      background: $base-color;
      width: 30%;
      height: 200px;
      border-radius: 6px;
      span {
        align-self: center;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/map/regionDetail.vue